module.exports = {
      id: "prothomalo-trust-usage",
      viewBox: "0 0 260 65",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#prothomalo-trust",
      toString: function () {
        return this.url;
      }
    }